<router-outlet *ngIf="styleService.theme == theme.webBrightTheme"></router-outlet>
<app-placid *ngIf="styleService.theme == theme.webDarkTheme"></app-placid>
<app-app-viho  *ngIf="styleService.theme == theme.desktopBrightTheme"></app-app-viho>
<app-dark-viho  *ngIf="styleService.theme == theme.desktopDarkTheme"></app-dark-viho>

<app-loader></app-loader>